import { QuestionBase } from './base.question.class'

export class CheckboxQuestion extends QuestionBase<string[]> {
  controlType = 'checkbox'

  constructor(options: {} = {}) {
    super(options)
    if (this.isCustom) {
      this.options = options['options']['checkbox-opts'] || []
    } else {
      this.options = options['options'] || []
    }
  }
}
